import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, CircularProgress } from '@mui/material';
import { API_ENDPOINTS } from '../../../constants/apiEndpoints';
import { useAuth } from '../../../context/AuthContext';

const AzureStorageTable = ({ refresh }) => {
  const { apiFetch } = useAuth();
  const [blobs, setBlobs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBlobs = async () => {
    setLoading(true);
    try {
      const response = await apiFetch(API_ENDPOINTS.AZURE_STORAGE_LIST);
      const data = await response.json();
      setBlobs(data.blobs || []);
    } catch (error) {
      console.error('Error fetching blobs:', error);
    }
    setLoading(false);
  };

  const handleDownload = async (blobName) => {
    try {
      const response = await apiFetch(`${API_ENDPOINTS.AZURE_STORAGE_SAS}?blob_name=${encodeURIComponent(blobName)}`);
      const data = await response.json();
      if (data.sas_url) {
        window.open(data.sas_url, '_blank');
      } else {
        alert('Failed to generate SAS URL');
      }
    } catch (error) {
      console.error('Error generating SAS URL:', error);
    }
  };

  useEffect(() => {
    fetchBlobs();
  }, [refresh]);

  if (loading) return <CircularProgress />;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Blob Name</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {blobs.map((blob, index) => (
            <TableRow key={index}>
              <TableCell>{blob}</TableCell>
              <TableCell align="right">
                <Button variant="contained" size="small" onClick={() => handleDownload(blob)}>
                  Download
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {blobs.length === 0 && (
            <TableRow>
              <TableCell colSpan={2} align="center">No blobs found</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AzureStorageTable;